import { useIntl } from 'react-intl';
import {
  facebookLogo,
  greenwayHealth,
  instagramLogo,
  linkedInLogo,
  twitterLogo,
  youtubeLogo,
} from '@marketplace/ui-elements';

import classes from './footer.module.scss';

export const New_footer = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={(classes.base_template__footer)}>
      © {formatMessage({
          id: 'shared_copyrights_calendar_year',
        })} All rights reserved. Greenway Health, LLC&nbsp;-&nbsp;
      
      <a href="https://developers.greenwayhealth.com/developer-platform/page/terms-of-service"
        target='_blank'
        rel="noreferrer noopener"
      >
        {formatMessage({
          id: 'developer_landing_footer_terms_of_service',
        })}
      </a>&nbsp;-&nbsp;
      <a href="https://developers.greenwayhealth.com/developer-platform/page/privacy-policy" 
        target='_blank'
        rel="noreferrer noopener"
      >
        {formatMessage({
          id: 'developer_landing_footer_privacy_policy',
        })}
      </a>
    </div>

  )
}

export const Footer = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={classes.root}>
      <div className={classes.copyrigths}>
        <a href="#" className={classes.copyrigthsItem}>
          {formatMessage({
            id: 'developer_landing_footer_terms_and_conditions',
          })}
        </a>
        |
        <a href="#" className={classes.copyrigthsItem}>
          {formatMessage({
            id: 'developer_landing_footer_best_practices',
          })}
        </a>
        |
        <a href="#" className={classes.copyrigthsItem}>
          {formatMessage({
            id: 'developer_landing_footer_privacy_statement',
          })}
        </a>
        |
        <span className={classes.copyrightsLine}>
          {formatMessage({
            id: 'shared_copyrights_calendar_year',
          })}
        </span>
      </div>

      <div>
        <img src={greenwayHealth} alt="" />
        <div className={classes.socials}>
          <a
            id="facebook-link"
            href="https://www.facebook.com/GreenwayHealthLLC"
            target="_blank"
          >
            <img src={facebookLogo} alt="" />
          </a>
          <a
            id="twitter-link"
            href="https://twitter.com/greenway"
            target="_blank"
          >
            <img src={twitterLogo} alt="" />
          </a>
          <a
            id="linkedin-link"
            href="https://www.linkedin.com/company/greenway-health/"
            target="_blank"
          >
            <img src={linkedInLogo} alt="" />
          </a>
          <a
            id="instagram-link"
            href="https://www.instagram.com/greenwayhealth/"
            target="_blank"
          >
            <img src={instagramLogo} alt="" />
          </a>
          <a
            id="youtube-link"
            href="https://www.youtube.com/user/GreenwayHealthLLC"
            target="_blank"
          >
            <img src={youtubeLogo} alt="" />
          </a>
        </div>
      </div>
    </div>
  );
};
